/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_9_AInputs */

const en_pc_faq_9_a = /** @type {(inputs: Pc_Faq_9_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject and object selection run on-device. Generative features such as AI fill are not in PhotoCraft yet. ArtCraft's AI image and video tools are a separate app.`)
};

const zh_pc_faq_9_a = /** @type {(inputs: Pc_Faq_9_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主体和对象选择在本地运行。AI 填充这类生成式功能尚未加入 PhotoCraft，ArtCraft 的 AI 图像和视频工具是另一个独立应用。`)
};

/**
* | output |
* | --- |
* | "Subject and object selection run on-device. Generative features such as AI fill are not in PhotoCraft yet. ArtCraft's AI image and video tools are a separate..." |
*
* @param {Pc_Faq_9_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_9_a = /** @type {((inputs?: Pc_Faq_9_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_9_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_9_a(inputs)
	return zh_pc_faq_9_a(inputs)
});
export { pc_faq_9_a as "pc.faq.9.a" }